"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "casarsa-della-delizia": {
    "9db00813": [{
      "hkey": "25088abc",
      "slug": "casarsa-della-delizia",
      "name": "Casarsa della Delizia",
      "primary": true,
      "skipSearch": false
    }],
    "comunale": [{
      "hkey": "25088abc",
      "slug": "casarsa-della-delizia",
      "name": "Casarsa della Delizia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "95b34e91": [{
      "hkey": "25088abc",
      "slug": "casarsa-della-delizia",
      "name": "Casarsa della Delizia",
      "primary": true,
      "skipSearch": false
    }],
    "san-floriano": [{
      "hkey": "25088abc",
      "slug": "casarsa-della-delizia",
      "name": "Casarsa della Delizia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "139e2469": [{
      "hkey": "25088abc",
      "slug": "casarsa-della-delizia",
      "name": "Casarsa della Delizia",
      "primary": true,
      "skipSearch": false
    }],
    "san-giovanni": [{
      "hkey": "25088abc",
      "slug": "casarsa-della-delizia",
      "name": "Casarsa della Delizia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "35719fa3": [{
      "hkey": "25088abc",
      "slug": "casarsa-della-delizia",
      "name": "Casarsa della Delizia",
      "primary": true,
      "skipSearch": false
    }],
    "sile": [{
      "hkey": "25088abc",
      "slug": "casarsa-della-delizia",
      "name": "Casarsa della Delizia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c44330a4": [{
      "hkey": "25088abc",
      "slug": "casarsa-della-delizia",
      "name": "Casarsa della Delizia",
      "primary": true,
      "skipSearch": false
    }],
    "versa": [{
      "hkey": "25088abc",
      "slug": "casarsa-della-delizia",
      "name": "Casarsa della Delizia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;